<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeMenu"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeMenu" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>
  </div>
</template>

<script>
import { Model } from "survey-core";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import { addClassQlEditorToSDDisplay, customThemeSurveyJS } from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeMenu",
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: null,
    survey: null,
    surveyJson: null,
    themeJson: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    header: null,
  }),
  async created() {
    await this.getCampaign();
    await this.getUser();
    await this.getSurveyAndTheme();

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    this.handleClickMenu();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    async getUser() {
      try {
        const response = await MicrositeAxios.get(
          `checkPhoneNumber/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );
        const userExists = response?.data?.data?.users;
        if (userExists) {
          this.$store.commit("microsite/SET_USER", {
            user: {
              phone: userExists ? userExists.phone : this.user.phone,
              fullname: userExists ? userExists.fullname : null,
              line_id: userExists ? userExists.line_id : null,
              detail: userExists ? userExists.detail : null,
              history: userExists ? userExists.CampaignTransaction : null,
              status_consent: userExists ? userExists.status_consent : null,
            },
          });
        } else {
          this.$swal
            .fire({
              icon: "error",
              title: this.$t("microsite.dataNotFound"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-login" });
          });
        console.log(error);
      }
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);

      if (surveyJson && surveyJson.login) {
        let loginJson = surveyJson.login;
        this.header = loginJson["elements"][0];
      }
      if (surveyJson && surveyJson.menu) {
        this.surveyJson = surveyJson.menu;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).menu;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    handleClickMenu() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        if (
          [
            "register",
            "topSpender",
            "code",
            "history",
            "history_code",
            "announcement",
            "game",
            "edit_profile",
          ].includes(options.question.name)
        ) {
          const element = options.htmlElement;

          element.style.cursor = "pointer"; // Optional: Change cursor to indicate clickable

          element.onclick = () => {
            switch (options.question.name) {
              case "register":
                if (this.campaign.split_register_page) {
                  this.$router.push({ name: "microsite-bill" });
                } else {
                  this.$router.push({ name: "microsite-register" });
                }
                break;
              case "code":
                this.$router.push({ name: "microsite-code" });
                break;
              case "history":
                if (this.campaign.template_id == 5) {
                  this.$router.push({ name: "microsite-history-game" });
                } else {
                  this.$router.push({ name: "microsite-history" });
                }
                break;
              case "history_code":
                this.$router.push({ name: "microsite-history-code" });
                break;
              case "topSpender":
                this.$router.push({ name: "microsite-top-spender" });
                break;
              case "announcement":
                this.$router.push({ name: "microsite-announcement" });
                break;
              case "game":
                this.$router.push({ name: "microsite-game" });
                break;
              case "edit_profile":
                this.$router.push({ name: "microsite-edit_profile" });
                break;
            }
          };
        }
      });
    },
  },
};
</script>

<style scoped>
/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
